<template>
  <row>
    <col12>
    <row>
      <annotate-modal v-if="showModal && modalAssetId"
                      :model_id="model_id"
                      @remove_item="removeItem"
                      @close_modal="closeModal" :asset_id="modalAssetId"
      ></annotate-modal>
      <col10>
        <slot name="menu"></slot>
      </col10>
      <col2 v-if="!no_toggle">
        <checkbox v-if="items.length > 0" v-model="toggleAllChecked" @toggled="toggleSelectAll" :label="$t('myboxes.checkbox')"></checkbox>
      </col2>
    </row>
    <row>
      <col12>
        <row  v-if="grid_size === 2">
          <col6
              v-for="image in items" :key="image.bbox_id"
              :class="{ selected_grid_item: image.bbox_id===selected_id }"
          >

            <grid-item :no_toggle="no_toggle"
                       :image="image"
                       :sensitive-blur="sensitiveBlurForGridImage(image)"
                       :status_chips_mode="status_chips_mode"
                       :show_relabel_dropdown="show_relabel_dropdown"
                       :show_incorrect_button="show_incorrect_button"
                       :show_model_correct_button="show_model_correct_button"
                       :incorrect-busy="incorrectBusyBboxId === image.bbox_id"
                       :model-correct-busy="modelCorrectBusyBboxId === image.bbox_id"
                       :relabeling="relabelingBboxId === image.bbox_id"
                       :selected="image.bbox_id===selected_id"
                       :checked="item_ids_selected.includes(image.bbox_id)"
                       @select_toggled="selectToggled"
                       @remove_item="removeItem"
                       @relabel="onRelabel"
                       @mark_incorrect="onMarkIncorrect"
                       @model_correct="onModelCorrect"
                       @select_item="selectGridItem" :validation="image.validation"
                       ></grid-item>
          </col6>
        </row>
        <row v-if="grid_size === 4">
          <col3
              v-for="image in items" :key="image.bbox_id"
              :class="{ selected_grid_item: image.bbox_id===selected_id }"
          >
          
            <grid-item :no_toggle="no_toggle"
                       :image="image"
                       :sensitive-blur="sensitiveBlurForGridImage(image)"
                       :status_chips_mode="status_chips_mode"
                       :show_relabel_dropdown="show_relabel_dropdown"
                       :show_incorrect_button="show_incorrect_button"
                       :show_model_correct_button="show_model_correct_button"
                       :incorrect-busy="incorrectBusyBboxId === image.bbox_id"
                       :model-correct-busy="modelCorrectBusyBboxId === image.bbox_id"
                       :relabeling="relabelingBboxId === image.bbox_id"
                       :selected="image.bbox_id===selected_id"
                       :checked="item_ids_selected.includes(image.bbox_id)"
                       @select_toggled="selectToggled"
                       @remove_item="removeItem"
                       @relabel="onRelabel"
                       @mark_incorrect="onMarkIncorrect"
                       @model_correct="onModelCorrect"
                       @select_item="selectGridItem" :validation="image.validation"
                       ></grid-item>
          </col3>
        </row>
      </col12>
    </row>
    </col12>
  </row>

</template>

<script>
import GridItem from "@/components/GridItem";
import AnnotateModal from "@/components/AnnotateModal";
import Col3 from "@/components/layout/Col3";
import Row from "@/components/layout/Row";
import Col10 from "@/components/layout/Col10";
import Col2 from "@/components/layout/Col2";
import Checkbox from "@/components/Checkbox";
import Col12 from "@/components/layout/Col12";
import Col6 from "@/components/layout/Col6";
import LoadSettingsMixin from "@/mixins/LoadSettingsMixin";
import CurrentUserMixin from "@/mixins/CurrentUserMixin.vue";
import {
  getBlurUnlessMetaFromSettings,
  shouldBlurAssetMeta,
} from '@/utils/sensitiveImageBlur';
import { blockAnnotateModalOpen, canOpenAnnotateModal } from '@/utils/annotateModalGuard';

export default {
  props: {
    items: {required: true},
    model_id: {default: false},
    no_toggle: {default: false},
    grid_size: {default: 4},
    /** Passed to GridItem; use 'myboxes' on My Boxes page for slimmer chips. */
    status_chips_mode: {
      type: String,
      default: 'default',
    },
    show_relabel_dropdown: {
      type: Boolean,
      default: false,
    },
    show_incorrect_button: {
      type: Boolean,
      default: false,
    },
    show_model_correct_button: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Col12,
    Checkbox,
    Col2,
    Col10,
    Col6,
    Row,
    Col3,
    AnnotateModal,
    GridItem
  },
  mixins: [LoadSettingsMixin, CurrentUserMixin],
  data() {
    return {
      selected_id: false,
      showModal: false,
      modalAssetId: false,
      modalDefaultOption: '',
      modalMeta: '',
      item_ids_selected: [],
      toggleAllChecked: false,
      relabelingBboxId: null,
      incorrectBusyBboxId: null,
      modelCorrectBusyBboxId: null,
    }
  },
  watch: {
    items() {
      this.item_ids_selected = []
      this.toggleAllChecked = false
    },
    item_ids_selected() {
      this.emitSelection();
    }
  },
  computed: {
    selected_index() {
      return this.items.map(item=>{return item.bbox_id;}).indexOf(this.selected_id)
    }
  },
  methods: {
    sensitiveBlurForGridImage(image) {
      const policy = getBlurUnlessMetaFromSettings(this.settings || []);
      return shouldBlurAssetMeta(image && image.meta, policy, this.is_sensitive_image_blur_exempt);
    },
    emitSelection() {
      const selected_images = this.items.filter((item) =>
        this.item_ids_selected.includes(item.bbox_id),
      );
      const annotation_ids = selected_images.map((item) => item.bbox_id);
      const asset_ids = selected_images.map((item) => item.asset_id || item.id);
      this.$emit('update_selection_asset_ids', asset_ids);
      this.$emit('update_selection_annotation_ids', annotation_ids);
      this.$emit('selection-change', annotation_ids);
      this.$emit('annotations-selected', annotation_ids);
    },
    toggleSelectAll (value) {
      if(value) {
        let item_ids = this.items.map(image=>{return image.bbox_id});
        this.item_ids_selected = item_ids
      }
      else {
        this.item_ids_selected = []
      }
      this.emitSelection();
    },
    addEvents: function(e) {
        let activeElement = document.activeElement;
        let inputs = ['input', 'select', 'button', 'textarea'];

        if (activeElement && inputs.indexOf(activeElement.tagName.toLowerCase()) !== -1) {
            return false;
        }

       if(!this.showModal && e.keyCode === 32) { //space
          e.stopPropagation();
          e.preventDefault();

          let index = this.selected_index
          let assetId = this.items[index].id || this.items[index].asset_id
          this.selectGridItem(assetId, this.items[index].bbox_id)
        }

        if(this.showModal) {
            return;
        }

        if(e.keyCode === 13) { //enter
          e.stopPropagation();
          e.preventDefault();
          this.$emit('reload')
        }

        if(e.keyCode === 39) { //right arrow
          e.stopPropagation();
          e.preventDefault();
          let i = this.items.map( item => {return item.bbox_id;} ).indexOf(this.selected_id);
          let newI = i + 1
          if(i === -1 || newI > this.items.length -1) {
            newI = 0
          }
          this.selected_id = this.items[newI].bbox_id;
        }

        if(e.keyCode === 37) { //left arrow
          e.stopPropagation();
          e.preventDefault();
          let i = this.items.map( item => {return item.bbox_id;} ).indexOf(this.selected_id);
          let newI = i -1
          if(newI < 0) {
            newI = this.items.length -1 ;
          }
          this.selected_id = this.items[newI].bbox_id;
        }

        if(e.keyCode === 38) { //Up arrow
          e.stopPropagation();
          e.preventDefault();
          let i = this.items.map( item => {return item.bbox_id;} ).indexOf(this.selected_id);
          let newI = i - this.grid_size
          if(newI < 0) {
            return;
          }
          this.selected_id = this.items[newI].bbox_id;
        }

        if(e.keyCode === 40) { //Down arrow
          e.stopPropagation();
          e.preventDefault();
          let i = this.items.map( item => {return item.bbox_id;} ).indexOf(this.selected_id);
          let newI = i + this.grid_size
          if(newI > this.items.length - 1) {
            return;
          }
          this.selected_id = this.items[newI].bbox_id;
        }

      },
    closeModal() {
      blockAnnotateModalOpen();
      this.modalAssetId = null;
      this.showModal = false;
    },
    selectGridItem(assetId, bboxId) {
      const resolvedAssetId = assetId || null;
      if (bboxId != null && bboxId !== '') {
        this.selected_id = bboxId;
      }
      if (!canOpenAnnotateModal()) {
        return;
      }
      if (!resolvedAssetId || this.modalAssetId || this.showModal) {
        return;
      }
      this.modalAssetId = resolvedAssetId;
      this.showModal = true;
    },
    removeItem(assetId) {
      this.$emit('remove_item', assetId)
    },
    onRelabel(bboxId, label) {
      this.$emit('relabel', bboxId, label);
    },
    onMarkIncorrect(bboxId) {
      this.$emit('mark_incorrect', bboxId);
    },
    onModelCorrect(bboxId) {
      this.$emit('model_correct', bboxId);
    },
    setRelabelingBboxId(bboxId) {
      this.relabelingBboxId = bboxId;
    },
    setIncorrectBusyBboxId(bboxId) {
      this.incorrectBusyBboxId = bboxId;
    },
    setModelCorrectBusyBboxId(bboxId) {
      this.modelCorrectBusyBboxId = bboxId;
    },
    selectToggled(itemId, checked) {
      let index = this.item_ids_selected.indexOf(itemId)
      if (checked === undefined) {
        if (index === -1) {
          this.item_ids_selected.push(itemId)
        } else {
          this.item_ids_selected.splice(index, 1);
        }
      } else if (checked) {
        if (index === -1) {
          this.item_ids_selected.push(itemId)
        }
      } else if (index !== -1) {
        this.item_ids_selected.splice(index, 1);
      }
      this.emitSelection();
    }
  },
  mounted() {
    window.addEventListener('keydown', this.addEvents);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.addEvents);
  },
}
</script>

<style scoped>

</style>